import { createContext, useContext, useState } from 'react';

export const createLayoutState = (props) => {
  const [state, setState] = useState({
    headerVisible: true,
    backUrl: '',
    backTitle: '',
    footerComponent: null,
    ...props,
  });

  const setHeaderVisible = (value) => {
    setState((prev) => ({ ...prev, headerVisible: value }));
  };

  const setLayoutFooter = (value) => {
    setState((prev) => ({ ...prev, footerComponent: value }));
  };

  const resetLayoutHeader = () => {
    setState((prev) => ({
      ...prev, backTitle: '', backUrl: '', headerVisible: true,
    }));
  };

  const setLayoutHeader = ({ backTitle, backUrl }) => {
    if (backTitle && backUrl) {
      setState((prev) => ({
        ...prev, backTitle, backUrl, headerVisible: true,
      }));
    } else {
      resetLayoutHeader();
    }
  };

  return {
    ...state,
    setLayoutFooter,
    setLayoutHeader,
    resetLayoutHeader,
    setHeaderVisible,
  };
};

export const HubLayoutContext = createContext({
  headerVisible: true,
  backUrl: '',
  backTitle: '',
  footerComponent: null,
  setLayoutFooter: () => {},
  setLayoutHeader: () => {},
  resetLayoutHeader: () => {},
  setHeaderVisible: () => {},
});

export const useHubLayout = () => useContext(HubLayoutContext);
